import { render, staticRenderFns } from "./BasePdfSignaturePositioner.vue?vue&type=template&id=ca442c00&scoped=true"
import script from "./BasePdfSignaturePositioner.vue?vue&type=script&lang=js"
export * from "./BasePdfSignaturePositioner.vue?vue&type=script&lang=js"
import style0 from "./BasePdfSignaturePositioner.vue?vue&type=style&index=0&id=ca442c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca442c00",
  null
  
)

export default component.exports